// FastAPI returns `detail` as a string for HTTPException and as a list of
// {loc, msg, ...} objects for 422 validation errors; always return a string.
export function getApiErrorMessage(err, fallback = "Something went wrong. Try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail
      .map((item) => {
        if (typeof item === "string") return item;
        const field = Array.isArray(item?.loc) ? item.loc.filter((part) => part !== "body").join(".") : "";
        const msg = item?.msg || "Invalid value";
        return field ? `${field}: ${msg}` : msg;
      })
      .join("; ");
  }
  return fallback;
}
